import { useWindowWidth } from "@features/adaptive/useWindowWidth";
import React, { FC, memo, ReactNode } from "react";
import { SliderSectionDesktop } from "./SliderSectionDesktop/dynamic";
import { SliderSectionMobile } from "./SliderSectionMobile/dynamic";

export interface SliderSectionProps {
  className?: string;
  style?: React.CSSProperties;
  cols: { desktop: number; tablet: number; mobile: number };
  withShowAll?: boolean;
  showAllMobileText?: string;
  showAllLink?: string;
  items?: ReactNode[];
  title: string;
  onShowAllScroll?: () => void;

  columnGap?: number;
  rowGap?: number;
  isSquare?: boolean;
}

const _SliderSection: FC<SliderSectionProps> = (props) => {
  const width = useWindowWidth();
  const isDesktop = width == "desktop";

  if (isDesktop) {
    return <SliderSectionDesktop {...props} />;
  }

  return <SliderSectionMobile {...props} />;
};

export const SliderSection = memo(_SliderSection);
